import React from 'react';

const Video = ({LinkVideo}) => (
    <section className="video-information-conalep">
        <iframe title="Video - Portafolio de César" width="300" height="190" src={LinkVideo} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>   
    </section>
)

export default Video;
